import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import { withSnackbar } from 'notistack';
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layouts/components/AppCard";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withRouter} from "react-router";
import {connect} from "trim-redux";
import axios from "axios";
import {defaultVariabls} from "../../../config";
import Typography from "@material-ui/core/Typography/Typography";
import Countdown from 'react-countdown';
import TrackingProgress from "./components/progress/TrackingProgress";
import Title from "../../components/elements/Title";
import clsx from "clsx";
import Logo from '../../../files/img/logo-w.png';
import Box from "@material-ui/core/Box/Box";
import {Link} from "react-router-dom";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar/Avatar";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ShoppingBasketRoundedIcon from '@material-ui/icons/ShoppingBasketRounded';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import AirplanemodeActiveRoundedIcon from '@material-ui/icons/AirplanemodeActiveRounded';
import DirectionsBoatRoundedIcon from '@material-ui/icons/DirectionsBoatRounded';
import AvTimerRoundedIcon from '@material-ui/icons/AvTimerRounded';
import Copyright from "../../components/elements/Copyright";
import Loader from "../../components/elements/Loader";
import HourglassFullRoundedIcon from '@material-ui/icons/HourglassFullRounded';
import Button from "@material-ui/core/Button/Button";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import IconButton from "@material-ui/core/IconButton/IconButton";
import moment from "jalali-moment";
import VerticalProgress from "./components/progress/VerticalProgress";

class Track extends React.Component {
    state = {
        loading: true,
        order: null,
        progress: 5
    };
    classes = this.props.classes;
    code = this.props.match.params.code;
    componentDidMount(){
        this.loadData();
        setInterval(() => {
            this.setState(prevState => ({
                progress:
                    (prevState.progress + Math.floor(Math.random() * 20) + 1) % 100
            }));
        }, 1000);
    }
    async loadData(){
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.get(`${defaultVariabls.url}/order/getByTrackingCode/${this.code}`, config)
            .then(response => {
                // eslint-disable-next-line
                this.setState({
                    order: response.data,
                    loading:false,
                })
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.trackingCodeNotFound, {
                    variant: 'error',
                });
                this.props.history.push(`/`)
            });
    }

    render(){
        let {loading,order} = this.state;
        return (
            <>
                {
                    loading ? <Loader/> :
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.orderTracking} >
                <Grid container justify="center" alignItems="center"  className={this.classes.trackPage}>
                    <Grid item xs={12}>
                        <div className={clsx('hero-header', this.classes.heroHeader)}>
                            <Box
                                component="a"
                                href={defaultVariabls.mainSite}
                                style={{
                                    cursor: "pointer",
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'center',
                                }}>
                                <img
                                    style={{height:45,margin:15}}
                                    src={Logo}
                                    alt={Translate.appName}
                                    title={Translate.appName}
                                />
                            </Box>
                            <Title>{Translate.orderTracking}</Title>
                            <div className="rechts1"></div>
                            <div className="rechts2"></div>
                        </div>
                    </Grid>
                    <Grid item xs={11}>
                        <Grid container spacing={2} justify="center" alignItems="center" style={{overflowX:"hidden"}}>
                            <Grid item xs={12} className="my-40 text-center">
                                <Typography className="track-code-holder">
                                    {Translate.orderTrackingCode}:
                                    <Link
                                        to={`/track/${this.code}`}
                                    >
                                        {this.code}
                                    </Link>
                                </Typography>
                                <Typography className="mt-15">
                                    {Translate.yourOrderIsAtStageOf}
                                    <strong style={{color:"#ff7600"}}> {order.transfer_type === "ship" ? order.status.ship_name : order.status.airplane_name}</strong>
                                    {" "}{Translate.is}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <VerticalProgress
                                    status_id={order.status.id}
                                    progress={Math.floor(order.status.id*11.2)}
                                    start_date={order.created_at}
                                    status={
                                        order.transfer_type === "ship" ?
                                            order.status.ship_name : order.status.airplane_name
                                    }
                                    end_time={
                                        <Typography>
                                            {Translate.durationEstimated}:
                                            <strong>
                                                {" "}{moment(order.deliver_at).locale('fa').format("D MMMM")} - {moment(order.deliver_at).add(20, 'days').locale('fa').format("D MMMM")}
                                            </strong>
                                        </Typography>
                                    }
                                >
                                    <Avatar color="primary">
                                        {
                                            order.transfer_type === "ship" ?
                                                <DirectionsBoatRoundedIcon />   :
                                                <AirplanemodeActiveRoundedIcon className="airplane-icon"/>
                                        }
                                    </Avatar>
                                </VerticalProgress>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <AppCard
                                    className="track-app-card"
                                    style={{height:"100%"}}
                                    title={Translate.orderDetails}
                                >
                                    <Grid container spacing={2} alignItems="center" justify="center">
                                        <Grid item xs={12}>
                                            <List>
                                                <ListItem>
                                                    <ListItemAvatar>
                                                        <Avatar>
                                                            <ShoppingBasketRoundedIcon />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={
                                                            <Typography>{Translate.orderTitle}: <strong> {order.title}</strong></Typography>
                                                        }
                                                    />
                                                </ListItem>
                                                <ListItem>
                                                    <ListItemAvatar>
                                                        <Avatar>
                                                            <DescriptionRoundedIcon />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={
                                                            <Typography>{Translate.orderDetails}: <strong> {order.description}</strong></Typography>
                                                        }
                                                    />
                                                </ListItem>
                                                <ListItem>
                                                    <ListItemAvatar>
                                                        <Avatar>
                                                            {
                                                                order.transfer_type === "ship" ?
                                                                    <DirectionsBoatRoundedIcon />   :
                                                                    <AirplanemodeActiveRoundedIcon/>
                                                            }
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={
                                                            <Typography>{Translate.transferType}: <strong> {Translate[order.transfer_type]}</strong></Typography>
                                                        }
                                                    />
                                                </ListItem>
                                            </List>
                                        </Grid>
                                    </Grid>
                                </AppCard>
                            </Grid>

                            <Grid item xs={12} className="text-center mt-15">
                                <Button
                                    component="a"
                                    href={defaultVariabls.mainSite}
                                    target="_blank"
                                    color="primary"
                                    variant="contained"
                                    size="large"
                                >
                                    {Translate.goBackToDarkoob}
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Copyright/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AppAnimate>
                }
                    </>
        );
    }
}
const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Track)))));